//Utils
import { stringifyNestedKeyPaths } from "@utils/object-helpers";
import { diff } from "deep-object-diff";
import get from "lodash/get";
//Custom Widgets
import ColorPickerWidget from "../form-customizations/ColorPickerWidget";
import GeneralInputField from "../form-customizations/GeneralInputField";
import { mergeAndHandleVisibilitySettings } from "../sypi-interface";

export const logDiffs = (initialConfig, currentConfig) => {
  let objectDiff = diff(initialConfig, currentConfig);
  let revisedPaths = stringifyNestedKeyPaths(objectDiff);
  return revisedPaths.reduce((acc, cur) => {
    const diffValue = get(objectDiff, cur);
    acc[cur] = diffValue === undefined ? null : diffValue;
    return acc;
  }, {});
};

export const setUISchema = (schemaConfig) => {
  const aPaletteVals = ["color_hex", "palette", "text_palette"];
  let ui = Object.keys(schemaConfig).reduce((acc, cur) => {
    if (schemaConfig[cur]?.properties) {
      acc[cur] = setUISchema(schemaConfig[cur].properties);
    } else if (
      schemaConfig[cur]?.["$ref"] &&
      aPaletteVals?.includes(
        schemaConfig[cur]["$ref"]?.split("#/definitions/")[1]
      )
    ) {
      acc[cur] = { "ui:widget": ColorPickerWidget };
    } else if (
      schemaConfig[cur]?.type === "array" ||
      Array.isArray(schemaConfig[cur]?.type)
    ) {
      acc[cur] = { items: { "ui:widget": GeneralInputField } };
    } else {
      acc[cur] = { "ui:widget": GeneralInputField };
    }
    return acc;
  }, {});
  return ui;
};
